import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as FileDocumentRemove } from 'assets/icons/file_document_remove.svg';

export const NoLicence = () => {
    return (
        <Box textAlign='center' height='100%' width='100%' display='flex' margin='auto'>
            <Box margin='auto' width='400px'>
                <Box width='76px' height='76px' margin='auto'>
                    <FileDocumentRemove />
                </Box>
                <Typography variant='h5' margin='24px 0 16px'>
                    Wyczerpany limit stron
                </Typography>
                <Typography variant='subtitle2'>
                    Nie możemy wyświetlić dokumentu(ów), ponieważ nie posiadasz wystarczającej ilości środków.
                </Typography>
            </Box>
        </Box>
    );
};
